import React, { Component } from "react";
import {map} from "lodash";
import * as yup from "yup";
import Loader from "../../../../Common/Component/Loader";
import {errorHandle} from "../../../../Common/errorHandle";
import {Drawer, message, Select, Radio, Space} from "antd";
import AmountInput from "../../../../../Common/amountInput";
import { formatToCurrency } from "../../../../../Tools/formatToCurrency";

const {Option} = Select;
class RefundPayment extends Component {
  state = {
    loader: false,
    staffList: {},
    errors: {},
    franchise_uuid: '',
    invoice_uuid: '',
    received_by_uuid: '',
    user_uuid: '',
    amount: '',
    reason: '',
    issueTo: this.props?.cardList?.count === 0 ? 'check' : 'cc',
    list: this.props?.List,
    refundType:this.props.refundTypeValue===null?'invoice':'',
    actionIssueRefund:this.props.actionIssueRefund,
    authUser:'',
    payment_method_type:this.props.invoice_uuid.payment_method_type,
    cardList: this.props.cardList,
    amount_received: 0,
    amount_received_error: false,
    refundTypeValue:this.props.refundTypeValue,
  }

  componentDidMount = () => {
    const { customerId } = this.props;

    if(this.props.invoice_uuid.uuid){
      this.setState({
        invoice_uuid:this.props.invoice_uuid.uuid
      })
    }
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const associated_field_offices = authUser?.user?.associated_field_offices?.map(x => x.uuid);

    this.props.getStaffUsers({ staff_profile__field_office__uuid: associated_field_offices?.[0] });
    this.setState({
      franchise_uuid: associated_field_offices?.[0],
      received_by_uuid: authUser?.user?.uuid,
      user_uuid: customerId,authUser:authUser?.user?.first_name+" "+authUser?.user?.last_name
    });
    
    if(this.props.invoice_uuid.uuid){
      this.props.getInvoiceById(this.props.invoice_uuid.uuid);
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { invoice_uuid,amount_received } = this.state;
   
    if (Object.keys(nextProps?.Invoice?.errors).length > 0 && nextProps?.Invoice?.errors !== this.props?.Invoice?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.Invoice?.errors)
    }

    //Get Invoice List
    if (Object.keys(nextProps?.Invoice?.invoiceDetail).length > 0
      && JSON.stringify(nextProps?.Invoice?.invoiceDetail?.amount_received) !== JSON.stringify(amount_received)) {
      this.setState({
        loader: false,
        amount_received: nextProps?.Invoice?.invoiceDetail?.amount_received-nextProps?.Invoice?.invoiceDetail?.refund_amount
      })
    }
    // Get staff list
    if (nextProps?.Invoice && Object.keys(nextProps?.Invoice?.staffList).length > 0
      && JSON.stringify(this.props.Invoice?.staffList) !== JSON.stringify(nextProps?.Invoice?.staffList)) {
      this.setState({ staffList: nextProps?.Invoice?.staffList, loader: false })
    }

    if (nextProps.invoice_uuid && nextProps.invoice_uuid !== invoice_uuid) {
      this.setState({ invoice_uuid: nextProps.invoice_uuid.uuid, loader: false })
    }

    // Get staff list
    if (nextProps?.Invoice && Object.keys(nextProps?.Invoice?.refundPayment).length > 0
      && JSON.stringify(this.props.Invoice?.refundPayment) !== JSON.stringify(nextProps?.Invoice?.refundPayment)) {
      message.success(nextProps?.Invoice?.refundPayment?.message, 8)

      setTimeout(() => this.setState({ loader: false }, () => {
        this.onClear()
        this.props.getInvoiceList()
        this.props.getInvoiceSummary()
      }), 1000)
    }

    // Get remaining credit balance
    if (nextProps?.RemainingCreditBalance?.data && nextProps?.RemainingCreditBalance?.data !== this.props.RemainingCreditBalance?.data) {
      this.setState({
        loader: false,
        amount: nextProps?.RemainingCreditBalance?.data?.amount === 0 ? '' : nextProps?.RemainingCreditBalance?.data?.amount,
        amount_received: nextProps?.RemainingCreditBalance?.data?.amount
      });
    }
  }

  // On text change
  onTextChange = (e, type) => { 
    const { customerId } = this.props;

    if(e.target.name === "invoice_uuid"){
      let v = JSON.parse(e.target.value);
      this.props.getInvoiceById(v.uuid);
      this.setState({ 
        [e.target.name]: v.uuid,
        payment_method_type:v.payment_method_type 
      });
    }else if(e.target.value === "pre-payment"){
      const invoiceList = this.state?.list?.map(l => {
        return l.uuid;
      });

      const value = type === 'bool' ? e.target.checked : e.target.value;
      this.setState({ 
        [e.target.name]: value, 
        invoice_uuid:invoiceList?.join("#"),
        payment_method_type:'',
        amount: '', 
        amount_received: 0
      });

      this.props.remainingCreditBalance({'customer_uuid': customerId});
      
    }else{
      const value = type === 'bool' ? e.target.checked : e.target.value;
      this.setState({ [e.target.name]: value});
    }

    if(e.target.value === 'pre-payment' || e.target.value === 'invoice')
    {
      this.setState({amount: '', amount_received: 0});
    }
  }

  // On search received by
  onSearchReceivedBy = (search) => {
    if (search?.length === 0 || search?.length >= 3) {
      this.props.getStaffUsers({ search: search, staff_profile__field_office__uuid: this.state.franchise_uuid })
    }
  }

  // Validate required fields
  validate = () => {
    const { invoice_uuid, received_by_uuid, amount,refundType,amount_received } = this.state;
    if(amount>amount_received || amount === 0 || amount==="0.00" || amount===""){
      this.setState({
        amount_received_error:true
      })
    }else{
      this.setState({
        amount_received_error:false
      })
    }
    const schema = yup.object().shape({
      refundType:yup.string().required("Select any Refund Type"),
      invoice_uuid: yup.string().when('refundType', {
        is: 'invoice',
        then: yup.string().required("Select any Invoice"), 
      }),
      received_by_uuid: yup.string().required("Received by is required"),
      amount: yup.string().required("Amount is required")
    });
    const data = {  invoice_uuid, received_by_uuid, amount,refundType };
    setTimeout(() => {
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({ is_btn_active: true, errors: {} });
        if(amount_received >= amount && amount !== ""){
          this.onRefund();
        }
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => {
          err_data[item.path] = item.message;
        });
        this.setState({ errors: err_data, is_btn_active: false });
      });
    }, 200);
  };

  onRefund = () => {
    const {
      invoice_uuid,
      received_by_uuid,
      amount,
      reason,
      issueTo,
      refundType,
      user_uuid
    } = this.state;

    let data = {
      processed_by: received_by_uuid ,
      amount,
      reason,
      issue_to:issueTo,
      refund_type:refundType
    }

    if(refundType === 'pre-payment')
    {
      data = {...data, customer_uuid: user_uuid}
    }
    else
    {
      data = {...data, invoice: invoice_uuid}
    }

    this.setState({loader: true});
    this.props.refundPayment({...data});
  }

  onClear = () => {
    this.setState({invoice_uuid: '', received_by_uuid: '', amount: '', reason: '',actionIssueRefund:false,payment_method_type:'',refundType:''}, () => this.props.closeDrawer(),this.props.clearRefund())
  }

  onChangeIssueTo = e => {
    this.setState({issueTo: e.target.value});
  };

  onAmountChange = (value) => {
    this.setState({ "amount_received": value, amount: value });
  }

  render() {
    const { visible } = this.props;
    const { 
      loader,
      amount,
      received_by_uuid,
      reason,
      staffList,
      errors,
      issueTo,
      list,
      refundType,
      invoice_uuid,
      actionIssueRefund,
      payment_method_type,
      cardList,
      amount_received_error,
      amount_received,
      actionValue,
      refundTypeValue
    } = this.state;
    let filterList = [];

    filterList = list?.filter(function( rf ) { 
      return rf.status !== 'draft';
    });

    return (
      <Drawer
        placement={'right'}
        closable={false}
        onClose={() => this.onClear()}
        visible={visible}
        key={'right'}
        width={'400'}
        className="drawer-wrapper"
      >
        <div className="rdrawer log_payment_drawer">
          <div className="card-row">
            <div className="card-full">
              {loader && <Loader/>}
              <h4>Refund Payment</h4>
              <div className={'form-group'}>
                <div className="fitem text_with_place">
                  <label>Refund Type</label><label style={{color:'red'}}> &nbsp;*</label>
                  <div className="refund_select">
                    <Select
                      onChange={(e) => this.onTextChange({target: {name: 'refundType', value: e}}) }
                      defaultValue={refundTypeValue === null ? "invoice":'Refund Type'}
                      placeholder="Refund Type"
                      disabled={actionIssueRefund ? false : true}
                      className="swhite">
                      <Option value="invoice">Invoice</Option>
                      <Option value="pre-payment">Pre-Payment Balance</Option>
                    </Select>
                  </div>
                  {errors?.['refundType'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['refundType']}</label> : ''}
                </div>
                {refundType === "invoice" ? <div className="fitem text_with_place">
                  <div className="refund_select">
                    <Select
                      onChange={(e) => this.onTextChange({target: {name: 'invoice_uuid', value: e}}) }
                      defaultValue={actionIssueRefund?"Select Invoice":this.props.invoice_uuid.invoice_id}
                      disabled={actionIssueRefund?false:true}
                      className="swhite">
                      {map(filterList, (item) => {
                        if (item?.invoice_id) {
                          return (
                            <Option key={JSON.stringify(item)}>{item?.invoice_id}</Option>
                          )
                        }
                      })}
                    </Select>
                  </div>  
                  {errors?.['invoice_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['invoice_uuid']}</label> : ''}
                </div>:null}
                <div className="fitem text_with_place">
                  <label>Issue to</label><label style={{color:'red'}}> &nbsp;*</label>
                </div>
                <div className="fitem text_with_place">
                  <Radio.Group
                    className="swhite"
                    onChange={this.onChangeIssueTo}
                    value={issueTo}
                  >
                    <Space direction="vertical">
                      <Radio value={"check"}>Check</Radio>
                      <Radio disabled={cardList?.count === 0} value={"cc"}>Credit Card</Radio>
                    </Space>
                  </Radio.Group>
                  {errors?.['issueTo'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['issueTo']}</label> : ''}
                </div>
                <div className="fitem text_with_place amount">
                  <label>Amount <span style={{color:'red'}}> &nbsp;*</span></label>
                  <div style={{"position": "relative"}}>
                    <AmountInput
                      type="text"
                      name="amount"
                      value={amount}
                      placeholder="0.00"
                      inputMode="decimal"
                      className={`twhite ${refundType === 'pre-payment' ? 'disable' : ''}`}
                      disabled={refundType === 'pre-payment' ? true : false}
                      onChange={(e) => this.onAmountChange(e)}
                    />
                  </div>
                  {amount ? <div className="fix_isd_code t-25"><span>$</span></div> : ''}
                  {
                    amount_received_error ? 
                      <label className="new_err_msg">
                        <i className="las la-info-circle" />{amount===""?`Amount is required!`:amount_received===0?`Refund is not applicable for this Invoice !`:`Amount should be less then or equal to $${formatToCurrency(amount_received)} !`}
                      </label> : ''}
                </div>
                <div className="fitem">
                  <label>Reason</label>
                  <textarea
                    className="refund_select"
                    rows="5"
                    name="reason"
                    type="text"
                    placeholder={"Describe the reason why this refund is being generated."}
                    value={reason}
                    onChange={(e) => this.onTextChange(e)} />
                </div>
                <div className="fitem">
                  <label>Issued By</label><label style={{color:'red'}}> &nbsp;*</label>
                  <div className="refund_select">
                    <Select
                      showSearch
                      filterOption={false}
                      value={received_by_uuid}
                      defaultValue={this.state.authUser}
                      onBlur={() => this.onSearchReceivedBy()}
                      onSearch={(e) => this.onSearchReceivedBy(e)}
                      onChange={(e) => this.onTextChange({target: {name: 'received_by_uuid', value: e}}) }
                      className="swhite"
                    >
                      <Option value={received_by_uuid}>{this.state.authUser}</Option>
                    </Select>
                  </div>
                  {errors?.['received_by_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['received_by_uuid']}</label> : ''}
                </div>
              </div>
            </div>
            <div className="footer" style={{ 'width': '400px' }}>
              <button
                className="btn btn-brand btn-bdr"
                onClick={() => this.onClear()}
              >Cancel</button>
              <button
                className={`btn btn-warning`}
                onClick={() => this.validate()}
              >Refund</button>
            </div>
          </div>
        </div>
      </Drawer>
    );
  }
}

export default RefundPayment;